export const pageSize = 30
export const currentRightsholderLocalStorageKey = 'current-rightsholder'
export const RIGHTS_PAGE_GAP = 2000;
export const STATEMENTS_PAGE_GAP = 100;
export const RIGHTSHOLDERS_PAGE_GAP = 100;
export const NOTIFICATIONS_PAGE_GAP = 500;
export const NOTIFICATIONS_POLL_INTERVAL = 30000;
export const DEBOUNCE_TIMEOUT = 1000;
export const CLAIMFORMS_GAP = 2000;